import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import LoadingSpinner from '../../../utils/LoadingSpinner';

import { get_workers_stats_comparison } from '../../../../actions/workerStatsActions';

const WorkersComparison = () => {
	const dispatch = useDispatch();

	const { all_worker_resources } = useSelector(state => state.workers);
	const { worker_stats_loading, workers_stats_comparison } = useSelector(state => state.workerStats);

	const [selectedWorkers, setSelectedWorkers] = useState([]);

	const workerOptions = (all_worker_resources?.workers || []).map(w => ({
		value: w._id,
		label: w.name || w.alias
	}));

	const handleCompare = () => {
		if (selectedWorkers.length >= 2) {
			const ids = selectedWorkers.map(w => w.value).join(',');
			dispatch(get_workers_stats_comparison(ids));
		}
	};

	const comparisonWorkers = workers_stats_comparison?.data?.workers || [];

	const chartData = comparisonWorkers.map(w => ({
		name: w.worker_name,
		total_jobs: w.performance?.total_jobs || 0,
		success_rate: w.performance?.success_rate || 0,
		jobs_per_minute: w.current_rate?.jobs_per_minute || 0
	}));

	return (
		<Card className='shadow-sm mb-3 card-border'>
			<Card.Body>
				<Card.Title className='text-center' as='h5'>Worker Comparison</Card.Title>
				<Row className='mb-3 align-items-end'>
					<Col xs={8}>
						<Select
							isMulti
							options={workerOptions}
							value={selectedWorkers}
							onChange={setSelectedWorkers}
							placeholder='Select workers to compare...'
						/>
					</Col>
					<Col xs={4}>
						<Button
							className='submit-btn w-100'
							onClick={handleCompare}
							disabled={selectedWorkers.length < 2 || worker_stats_loading}
						>
							<i className='bi bi-bar-chart me-2'></i> Compare
						</Button>
					</Col>
				</Row>

				{worker_stats_loading
					? <LoadingSpinner loadingMsg='Comparing workers' />
					: chartData.length > 0 &&
						<ResponsiveContainer width='100%' height={300}>
							<BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
								<CartesianGrid strokeDasharray='3 3' />
								<XAxis dataKey='name' fontSize={12} />
								<YAxis />
								<Tooltip />
								<Legend />
								<Bar dataKey='total_jobs' fill='#0d6efd' name='Total Jobs (24h)' />
								<Bar dataKey='jobs_per_minute' fill='#198754' name='Jobs/min (current)' />
							</BarChart>
						</ResponsiveContainer>
				}
			</Card.Body>
		</Card>
	);
}

export default WorkersComparison;
